import App from 'AppInterface/App';
import { logEvent } from 'components/telemetry';
import { Action } from 'redux';
import { AppParams, LocaleType } from 'types';

export const CHANGE_LOCALE = '@@ux/CHANGE_LOCALE';
export type CHANGE_LOCALE = typeof CHANGE_LOCALE;

export interface ChangeLocale extends Action {
	type: CHANGE_LOCALE;
	locale: LocaleType;
}

export const changeLocale = (locale: LocaleType): ChangeLocale => {
	return {
		type: CHANGE_LOCALE,
		locale: locale,
	};
};

export const UPDATE_BOOKLET_INDEX = '@@ux/UPDATE_BOOKLET_INDEX';
export type UPDATE_BOOKLET_INDEX = typeof UPDATE_BOOKLET_INDEX;

export interface UpdateBookletIndex extends Action {
	type: UPDATE_BOOKLET_INDEX;
	bookletId: string;
	index: number;
}

export const updateBookletIndex = (bookletId: string, index: number): UpdateBookletIndex => {
	return {
		type: UPDATE_BOOKLET_INDEX,
		bookletId,
		index,
	};
};

export const UPDATE_ACTIVE_NOTIFICATIONS = '@@ux/UPDATE_ACTIVE_NOTIFICATIONS';
export type UPDATE_ACTIVE_NOTIFICATIONS = typeof UPDATE_ACTIVE_NOTIFICATIONS;

export interface UpdateActiveNotifications extends Action {
	type: UPDATE_ACTIVE_NOTIFICATIONS;
	count: number;
}

export const updateActiveNotifications = (count: number): UpdateActiveNotifications => {
	return {
		type: UPDATE_ACTIVE_NOTIFICATIONS,
		count,
	};
};

export const UPDATE_USER_SETTINGS = '@@ux/UPDATE_USER_SETTINGS';
export type UPDATE_USER_SETTINGS = typeof UPDATE_USER_SETTINGS;

export interface UpdateUserSettings extends Action {
	type: UPDATE_USER_SETTINGS;
	settings: { [key: string]: any };
	fromProfile?: boolean;
}

export const updateUserSettings = (settings: { [key: string]: any }, fromProfile?: boolean): UpdateUserSettings => {
	return {
		type: UPDATE_USER_SETTINGS,
		settings,
		fromProfile,
	};
};

export const UPDATE_APP_PARAMS = '@@ux/UPDATE_APP_PARAMS';
export type UPDATE_APP_PARAMS = typeof UPDATE_APP_PARAMS;

export interface UpdateAppParams extends Action {
	type: UPDATE_APP_PARAMS;
	appParams: AppParams;
}

export const updateAppParams = (appParams: AppParams): UpdateAppParams => {
	return {
		type: UPDATE_APP_PARAMS,
		appParams,
	};
};

export const UPDATE_SORT_ORDER = '@@ux/UPDATE_SORT_ORDER';
export type UPDATE_SORT_ORDER = typeof UPDATE_SORT_ORDER;

export interface UpdateSortOrder extends Action {
	type: UPDATE_SORT_ORDER;
	recordType: string;
	sortValue: string;
}

export const updateSortOrder = (recordType: string, sortValue: string): UpdateSortOrder => {
	return {
		type: UPDATE_SORT_ORDER,
		recordType,
		sortValue,
	};
};

export const UPDATE_FILTERS = '@@ux/UPDATE_FILTERS';
export type UPDATE_FILTERS = typeof UPDATE_FILTERS;

export interface UpdateFilters extends Action {
	type: UPDATE_FILTERS;
	recordType: string;
	filters: any;
}

export const updateFilters = (recordType: string, filters: any): UpdateFilters => {
	return {
		type: UPDATE_FILTERS,
		recordType,
		filters,
	};
};

export const ACK_NOTIFICATION = '@@ux/ACK_NOTIFICATION';
export type ACK_NOTIFICATION = typeof ACK_NOTIFICATION;

export interface AckNotification extends Action {
	type: ACK_NOTIFICATION;
	id: string;
	time: number;
}

export const ackNotification = (id: string): AckNotification => {
	return {
		type: ACK_NOTIFICATION,
		id,
		time: new Date().getTime() / 1000,
	};
};
